<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <TaxTraits />
    </v-card>
  </div>
</template>

<script>
import { TaxTraits } from '@/components/payoutsAndTaxes';

export default {
  name: 'TaxTraitsView',
  components: {
    TaxTraits,
  },
  data() {
    return {};
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch('fetchTaxTraitAll');
      this.$store.dispatch('fetchPayoutCreationTypes');
    },
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/taxTraits/TaxTraitsView.vue